
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { TranslateModule } from '@ngx-translate/core';

import { PMenuActionsComponent } from './pmenu.actions.component';
import { ActionsProcessModule } from './actions.process.module';

import { CHANGE_STATUS_SITUATION } from '../dossiers/dossierActions/change.situation.component';
import { ChangeStatusSituationModule } from '../dossiers/dossierActions/change.situation.module';
import { MenuModule } from 'primeng-lts/menu';
import { SetVariablesModule } from '../dossiers/dossierActions/setVariables.module';


@NgModule({
  declarations: [PMenuActionsComponent],
  imports: [ActionsProcessModule,
    TranslateModule,
    MenuModule, CommonModule, ChangeStatusSituationModule, SetVariablesModule
  ], exports: [PMenuActionsComponent]


})
export class PMenuActionsModule { }
